import {
  CigaretteSmokingIcon,
  FireAlarmIcon,
  IndoorClimateIcon,
  LeakDetectionIcon,
  NoiseIcon,
  OccupancyIcon,
} from "@minuthq/meatball-ui-icons"

import { getDeviceHardwareType } from "src/data/devices/logic/deviceLogic"
import { HardwareType } from "src/data/devices/types/deviceTypes"
import { TDevice } from "src/data/devices/types/deviceTypes"
import { ITranslateFunction } from "src/i18n/i18nTypes"
import { langKeys } from "src/i18n/langKeys"
import { SVGElement } from "src/utils/tsUtil"

export function getDeviceAlertBullets({
  devices,
  t,
}: {
  devices: TDevice[]
  t: ITranslateFunction
}) {
  const hardwareTypes = devices.map(
    (device) => getDeviceHardwareType(device.hardware_version).type
  )

  let bullets: { icon: SVGElement; title: string }[] = []

  if (hardwareTypes.includes(HardwareType.L1)) {
    bullets.unshift({
      icon: LeakDetectionIcon,
      title: t(langKeys.leak_detection_title),
    })
  }

  if (hardwareTypes.includes(HardwareType.M3)) {
    bullets.push(
      {
        icon: NoiseIcon,
        title: t(langKeys.sound_noise_monitoring),
      },
      {
        icon: CigaretteSmokingIcon,
        title: t(langKeys.smoking_detection_title),
      },
      {
        icon: IndoorClimateIcon,
        title: t(langKeys.indoor_climate),
      },
      {
        icon: OccupancyIcon,
        title: t(langKeys.crowd_detect_title),
      }
    )
  }
  if (hardwareTypes.includes(HardwareType.P2)) {
    bullets.push(
      {
        icon: NoiseIcon,
        title: t(langKeys.sound_noise_monitoring),
      },

      {
        icon: IndoorClimateIcon,
        title: t(langKeys.indoor_climate),
      },
      {
        icon: OccupancyIcon,
        title: t(langKeys.crowd_detect_title),
      }
    )
  }
  if (hardwareTypes.includes(HardwareType.A1)) {
    bullets.push(
      {
        icon: CigaretteSmokingIcon,
        title: t(langKeys.smoking_detection_title),
      },
      {
        icon: IndoorClimateIcon,
        title: t(langKeys.indoor_climate),
      }
    )
    bullets.unshift({
      icon: FireAlarmIcon,
      title: t(langKeys.fire_and_co_alarm_title),
    })
  }

  if (
    devices.length === 1 &&
    devices.some((device) => device.placed_outdoors) &&
    hardwareTypes.includes(HardwareType.M3)
  ) {
    bullets = [
      {
        icon: NoiseIcon,
        title: t(langKeys.sound_noise_monitoring),
      },
    ]
  }

  return bullets
    .filter((bullet, index) => bullets.indexOf(bullet) === index)
    .slice(0, 3)
}
